import { styled, keyframes } from '@mui/material';
import { colorPalettes } from '../../../context/theme';

const drive = keyframes`
  from {
    transform: translate3d(0,-30px,0);
  }

  to {
    transform: translate3d(0,30px,0);
  }
`;

export const StyledLoader = styled('span')`
  color: ${({ theme, color }) =>
    color ?? colorPalettes[theme.palette.mode].components.Loader.color};
`;

export const StyledStripes = styled('path')`
  animation: ${drive} 1s linear infinite;
`;
